import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetAppConfigRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetAppConfigResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getAppConfig = (request: GetAppConfigRequest, options?: CashRequestOptions) =>
  post<GetAppConfigRequest, GetAppConfigResponse>('/2.0/cash/get-app-config', request, {
    ...options,
    rejectOnError: true,
  })
